import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material";
import {HotspotCreatorService} from "../../../../service/http/hotspot-creator.service";
import {environment} from "../../../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {ChangeLinkByTocTreeComponent} from "./change-link-by-toc-tree/change-link-by-toc-tree.component";

@Component({
  selector: 'app-update-hotspot-dot-dialog',
  templateUrl: './update-hotspot-dot-dialog.component.html',
  styleUrls: ['./update-hotspot-dot-dialog.component.css']
})
export class UpdateHotspotDotDialogComponent implements OnInit {

  currentPackageIdGlobal: any;
  hotspotId: number;
  realImageWidth: number = 700;
  realImageHeight: number = 600;
  updateDotTarget: string = '';
  updateDotBaseId: string = '';

  floatNumberPattern = "^([0-9]+)(.([0-9]{3}))$";

  updateDotLabelFormControl = new FormControl('', [
    Validators.required
  ]);

  updateDotLinkFormControl = new FormControl('', [
    Validators.required
  ]);

  updateDotXFormControl = new FormControl('', [
  ]);

  updateDotYFormControl = new FormControl('', [
  ]);

  imageXsizeValidator(control: FormControl) {
    if(control.value <= this.realImageWidth) {
      return null;
    } else {
      return {
        errorX: 'x dot coordinate is out of range: ' + this.realImageWidth
      };
    }
  }

  imageYsizeValidator(control: FormControl) {
    if(control.value <= this.realImageHeight) {
      return null;
    } else {
      return {
        errorY: 'x dot coordinate is out of range: ' + this.realImageWidth
      };
    }
  }

  public updateDotFormGroup = new FormGroup({
            updateDotLabel: this.updateDotLabelFormControl,
            updateDotLink: this.updateDotLinkFormControl,
            updateDotX: this.updateDotXFormControl,
            updateDotY: this.updateDotYFormControl});

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<UpdateHotspotDotDialogComponent>,
              private hotspotCreatorService: HotspotCreatorService,
              private http: HttpClient,
              public dialog: MatDialog) {

    let currentPackageId = sessionStorage.getItem('currentPackageId');
    if(currentPackageId !== null) {
      this.currentPackageIdGlobal = currentPackageId;
    }

    this.hotspotId = this.data.hotspotId;

    this.http.get(`${environment.packagesManagerBackendUrl}` + '/hotspot-creator/download/hotspot-image-json/' + this.currentPackageIdGlobal + '/' + this.hotspotId)
      .subscribe(data => {

        this.realImageWidth = data["width"];
        this.realImageHeight = data["height"];

        this.updateDotXFormControl.setValidators([
          Validators.required,
          Validators.pattern(this.floatNumberPattern),
          this.imageXsizeValidator.bind(this)]);
        this.updateDotYFormControl.setValidators([
          Validators.required,
          Validators.pattern(this.floatNumberPattern),
          this.imageYsizeValidator.bind(this)]);
      });
  }

  ngOnInit() {
    this.updateDotFormGroup.setValue({
      updateDotLabel: this.data["hotspotDot"].label,
      updateDotLink: this.data["hotspotDot"].linkRef,
      updateDotX: this.data["hotspotDot"].x,
      updateDotY: this.data["hotspotDot"].y
    });
    this.updateDotTarget = this.data["hotspotDot"].linkTarget;
  }

  updateDot() {

    if(this.updateDotFormGroup.valid) {
      let hotspotDotLabel = this.updateDotFormGroup.get('updateDotLabel').value;
      let hotspotDotLinkRef = this.updateDotFormGroup.get('updateDotLink').value;
      let hotspotDotXpos = this.updateDotFormGroup.get('updateDotX').value;
      let hotspotDotYpos = this.updateDotFormGroup.get('updateDotY').value;

      this.hotspotCreatorService.updateHotspotDot(this.currentPackageIdGlobal, this.data["hotspotId"], this.data["updateDotId"],
        {
          'dot-label': hotspotDotLabel,
          "link-ref": hotspotDotLinkRef,
          "link-base-id": this.updateDotBaseId,
          "link-target": this.updateDotTarget,
          "x": hotspotDotXpos.toString(),
          "y": hotspotDotYpos.toString()
        })
        .subscribe();

      this.dialogRef.close();
    }
  }

  editDot() {

    let dialogRef = this.dialog.open(ChangeLinkByTocTreeComponent, {
      width: '30%',
      height: '45%',
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {

      let hotspotDotXpos = this.updateDotFormGroup.get('updateDotX').value;
      let hotspotDotYpos = this.updateDotFormGroup.get('updateDotY').value;

      this.updateDotBaseId = result.linkBaseId;

      this.updateDotFormGroup.setValue({
        updateDotLabel: result.dotLabel,
        updateDotLink: result.linkRef,
        updateDotX: hotspotDotXpos,
        updateDotY: hotspotDotYpos
      });

      //TODO, temporary fix due to toc.json, which has not for each link a target at the moment
      if (result.linkTarget != null){
        this.updateDotTarget = result.linkTarget;
      } else {
        this.updateDotTarget = 'dm/';
      }
    });
  }
}
